import { ILanguage } from '../models';
import { $api } from '../service';

export const getLanguage = async () => {
  const { data } = await $api.get<ILanguage>('/language');

  return { language: data };
};
